import React, { useState } from "react";
import { FiDownload, FiDollarSign, FiCalendar, FiCheckCircle, FiAlertCircle, FiSearch } from 'react-icons/fi';
import styles from "../../../styles/Header-css/ServicePartner/PartnerProfile/EarningsDashboard.module.css";

const EarningsDashboard = () => {
  const [activeTab, setActiveTab] = useState("today");
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [paymentFilter, setPaymentFilter] = useState("all");

  const topCards = {
    todayEarnings: 5000,
    weeklyEarnings: 25000,
  };

  const earningsStats = {
    today: { earnings: 1955, transactions: 2, commission: 345, netEarning: 1610 },
    week: { earnings: 6600, transactions: 5, commission: 990, netEarning: 5610 },
    month: { earnings: 48200, transactions: 28, commission: 7230, netEarning: 40970 },
  };

  const mockTransactions = [
    { id: "txn_001", bookingId: "BK_2024_001", customerName: "Priya Sharma", service: "House Cleaning", amount: 800, commission: 120, netEarning: 680, paymentMethod: "UPI", status: "paid", date: "2024-01-15", paidAt: "2024-01-15 18:00" },
    { id: "txn_002", bookingId: "BK_2024_002", customerName: "Rahul Kumar", service: "AC Repair", amount: 1500, commission: 225, netEarning: 1275, paymentMethod: "Cash", status: "processing", date: "2024-01-15" },
    { id: "txn_003", bookingId: "BK_2024_003", customerName: "Sneha Patel", service: "Plumbing", amount: 600, commission: 90, netEarning: 510, paymentMethod: "Card", status: "pending", date: "2024-01-14" },
  ];

  const handleTabSwitch = (tab) => setActiveTab(tab);

  const getStatusBadge = (status) => {
    switch (status) {
      case "paid": return <span className={`${styles.badge} ${styles["bg-green"]}`}>Paid</span>;
      case "processing": return <span className={`${styles.badge} ${styles["bg-orange"]}`}>Processing</span>;
      case "pending": return <span className={`${styles.badge} ${styles["bg-red"]}`}>Pending</span>;
      default: return <span className={`${styles.badge} ${styles["bg-gray"]}`}>Unknown</span>;
    }
  };

  const filteredTransactions = mockTransactions.filter(
    (t) =>
      (t.customerName.toLowerCase().includes(search.toLowerCase()) ||
        t.service.toLowerCase().includes(search.toLowerCase()) ||
        t.bookingId.toLowerCase().includes(search.toLowerCase())) &&
      (statusFilter === "all" || t.status === statusFilter) &&
      (paymentFilter === "all" || t.paymentMethod.toLowerCase() === paymentFilter.toLowerCase())
  );
  
  // --- REFACTORED: Stats data defined here for cleaner JSX and direct icon usage ---
  const statsData = [
    { icon: <FiDollarSign />, label: "Total Earnings", value: earningsStats[activeTab].earnings },
    { icon: <FiCheckCircle />, label: "Net Earning", value: earningsStats[activeTab].netEarning, color: styles["text-black"] },
    { icon: <FiCalendar />, label: "Transactions", value: earningsStats[activeTab].transactions },
    { icon: <FiAlertCircle />, label: "Commission", value: earningsStats[activeTab].commission, color: styles["text-red"] },
  ];

  return (
    <div className={styles.dashboardWrapper}>
      <h1 className={styles.dashboardTitle}>Earnings Dashboard</h1>
      <button className={`${styles.btn} ${styles.mb4}`} onClick={() => alert("Export clicked!")}>
        <FiDownload /> Export
      </button>

      {/* Top Earnings Cards */}
      <div className={`${styles.grid} ${styles["grid-2"]} ${styles.mb4}`}>
        <div className={`${styles.card} ${styles.flex} ${styles["items-center"]} ${styles["justify-between"]} ${styles["bg-green"]}`}>
          <div>
            <p className={`${styles["text-sm"]} ${styles["text-white"]}`}>Today's Earnings</p>
            <p className={`${styles["text-xl"]} ${styles["font-semibold"]}`}>₹{topCards.todayEarnings.toLocaleString()}</p>
          </div>
          <FiDollarSign className={styles["text-white"]} size={24}/>
        </div>
        <div className={`${styles.card} ${styles.flex} ${styles["items-center"]} ${styles["justify-between"]} ${styles["bg-blue"]}`}>
          <div>
            <p className={`${styles["text-sm"]} ${styles["text-white"]}`}>This Week</p>
            <p className={`${styles["text-xl"]} ${styles["font-semibold"]}`}>₹{topCards.weeklyEarnings.toLocaleString()}</p>
          </div>
          <FiCalendar className={styles["text-white"]} size={24}/>
        </div>
      </div>

      {/* Tabs */}
      <div className={styles.tabs}>
        {["today", "week", "month"].map((tab) => (
          <div
            key={tab}
            className={`${styles.tab} ${activeTab === tab ? styles.active : ""}`}
            onClick={() => handleTabSwitch(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </div>
        ))}
      </div>

      {/* Stats */}
      <div className={`${styles.grid} ${styles["grid-2"]} ${styles.mb4}`}>
        {statsData.map((stat, idx) => (
          <div key={idx} className={`${styles.card} ${styles.flex} ${styles["items-center"]} ${styles.gap3}`}>
            <span className={styles['text-muted']}>{stat.icon}</span>
            <div>
              <p className={`${styles["text-sm"]} ${styles["text-muted"]}`}>{stat.label}</p>
              <p className={`${styles["text-xl"]} ${styles["font-semibold"]} ${stat.color || ""}`}>
                {stat.label !== "Transactions" && "₹"}{stat.value.toLocaleString()}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* --- REFACTORED: Filter section JSX updated to match the new UI --- */}
      <div className={`${styles.card} ${styles.filterCard} ${styles.mb4}`}>
        <div className={styles.searchIcon}>
          <FiSearch size={20} />
        </div>
        <input
          className={styles.searchInput}
          type="text"
          placeholder="Search by customer, service, or booking ID..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className={styles.dropdownContainer}>
          <select className={styles.filterSelect} value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="all">All Status</option>
            <option value="paid">Paid</option>
            <option value="processing">Processing</option>
            <option value="pending">Pending</option>
          </select>
          <select className={styles.filterSelect} value={paymentFilter} onChange={(e) => setPaymentFilter(e.target.value)}>
            <option value="all">All Methods</option>
            <option value="UPI">UPI</option>
            <option value="Cash">Cash</option>
            <option value="Card">Card</option>
          </select>
        </div>
      </div>

      {/* Transactions */}
      <div className={styles["space-y-3"]}>
        {filteredTransactions.length === 0 ? (
          <div className={`${styles.card} ${styles["text-center"]}`}>
            <p className={styles["text-muted"]}>No transactions found.</p>
          </div>
        ) : (
          filteredTransactions.map((t) => (
            <div key={t.id} className={styles.card}>
              <div className={`${styles.flex} ${styles["justify-between"]} ${styles["items-start"]} ${styles.mb2}`}>
                <div>
                  <p className={styles["font-medium"]}>{t.customerName}</p>
                  <p className={`${styles["text-sm"]} ${styles["text-muted"]}`}>{t.service}</p>
                  <p className={`${styles["text-xs"]} ${styles["text-muted"]}`}>ID: {t.bookingId}</p>
                </div>
                <div className={styles["text-right"]}>
                  {/* --- FIX: Corrected className to use 'text-green' --- */}
                  <p className={`${styles["text-lg"]} ${styles["font-semibold"]} ${styles["text-black"]}`}>₹{t.netEarning.toLocaleString()}</p>
                  <p className={`${styles["text-sm"]} ${styles["text-muted"]}`}>of ₹{t.amount.toLocaleString()}</p>
                </div>
              </div>
              <div className={styles.separator}></div>
              <div className={`${styles.flex} ${styles["justify-between"]} ${styles["items-center"]} ${styles["text-sm"]}`}>
                <div>{getStatusBadge(t.status)}</div>
                <div className={`${styles["text-muted"]} ${styles.flex} ${styles.gap4}`}>
                  <span>{t.paymentMethod}</span>
                  <span>{t.date}</span>
                </div>
              </div>
              {t.paidAt && <p className={`${styles["text-xs"]} ${styles["text-green"]} ${styles.mt1}`}>Paid on {t.paidAt}</p>}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default EarningsDashboard;